var Transform = require('./Transform')

module.exports = function () {
  return Transform.IDENTITY
}
